import { Link } from 'react-router-dom';
import { heroData } from '@/mocks/nosotros-data';

export default function NosotrosHero() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Authentic%20documentary%20style%20photograph%20of%20peruvian%20musicians%20performing%20together%20in%20a%20warm%20intimate%20rehearsal%20space%2C%20natural%20light%20through%20windows%2C%20candid%20emotional%20expressions%2C%20cultural%20instruments%20visible%2C%20red%20and%20charcoal%20tones%2C%20artistic%20atmosphere%2C%20genuine%20moment%20between%20artists%2C%20editorial%20quality%2C%20human%20connection%20through%20music%2C%20no%20posing%2C%20natural%20composition&width=1920&height=1080&seq=soniem-nosotros-hero-01&orientation=landscape"
          alt="Artistas musicales peruanos - SONIEM"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-black/85" />
        <div className="absolute inset-0 bg-primary-900/15 mix-blend-multiply" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/10 backdrop-blur-sm border border-white/20 mb-6 md:mb-8">
            <span className="w-2 h-2 rounded-full bg-primary-400" />
            <span className="text-white/90 text-xs md:text-sm font-medium tracking-wide uppercase">
              Sociedad de Gestión Colectiva
            </span>
          </div>

          {/* Main Title */}
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-4 md:mb-6">
            {heroData.title}
          </h1>

          {/* Subtitle */}
          <p className="text-white/70 text-sm md:text-base lg:text-lg max-w-3xl mx-auto mb-10 md:mb-12 leading-relaxed">
            {heroData.subtitle}
          </p>

          {/* CTA */}
          <Link
            to="#historia"
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 whitespace-nowrap"
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('historia')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            <span>{heroData.ctaLabel}</span>
            <i className="ri-arrow-down-line group-hover:translate-y-1 transition-transform" />
          </Link>
        </div>
      </div>

      {/* Bottom brand text */}
      <div className="absolute bottom-0 left-0 right-0 pb-8 md:pb-12">
        <div className="px-4 md:px-6 lg:px-10">
          <p className="font-heading text-white/8 text-[10vw] md:text-8xl lg:text-9xl font-black leading-none select-none tracking-tighter text-center">
            NOSOTROS
          </p>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-4 md:bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="flex flex-col items-center gap-2">
          <span className="text-white/50 text-xs font-medium tracking-widest uppercase">Explorar</span>
          <div className="w-5 h-8 rounded-full border-2 border-white/30 flex items-start justify-center p-1">
            <div className="w-1 h-2 rounded-full bg-white/60 animate-bounce" />
          </div>
        </div>
      </div>
    </section>
  );
}